'use client'

import { useHasPermission } from '@/hooks/usePermissions'
import { useCachedQuery } from '@/lib/cache'
import { listChannelNames } from '@/services/channels'
import type { ChannelName } from '@/types/channel'

/** Gate de `GET /whatsapp/channels/names` no back. */
export const CHANNEL_NAMES_READ_PERMISSION = 'channels:names:read'

/**
 * Prefixo `['channels']` de propósito: `invalidateQueries({queryKey: ['channels']})`
 * casa por PREFIXO no TanStack, então o "Verificar novamente" da home e as mutations
 * de canal do admin também refrescam o roster — que é justamente o que muda quando
 * um canal nasce ou morre. O patch de contadores por socket (`useChannelCountersLive`)
 * usa `setQueryData(['channels'])`, que é chave EXATA e não encosta aqui.
 */
export const channelRosterKeys = { all: ['channels', 'names'] as const }

/**
 * Roster do tenant: todo canal, sem escopo. Responde IDENTIDADE ("como este channel_id
 * se chama", "pra onde dá pra transferir"), nunca ACESSO — acesso continua sendo
 * `useChatBot().channels`, derivado da lista escopada.
 */
export function useChannelRosterQuery() {
  const canRead = useHasPermission(CHANNEL_NAMES_READ_PERMISSION)
  return useCachedQuery<ChannelName[]>({
    queryKey: channelRosterKeys.all,
    queryFn: () => listChannelNames(),
    enabled: canRead,
    // O erro esperado é 403, que não se conserta com retry: 3 tentativas só
    // multiplicariam o log. A UI degrada pro escopado (mergeChannelRoster).
    retry: false,
  })
}
